import { notification } from "antd";
import {
  FETCH_UTILISATEURS_FAILURE,
  FETCH_UTILISATEURS_REQUEST,
  FETCH_UTILISATEURS_SUCCESS,
} from "../Types";
import { apiGet } from "../../services/apiInterceptor";

export const fetchUtilisateurs = () => {
  return async (dispatch) => {
    dispatch({ type: FETCH_UTILISATEURS_REQUEST });

    try {
      // ✅ MIGRATION : Plus besoin de gérer manuellement le token
      const response = await apiGet("api/users");
      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data?.message || "Erreur lors de la récupération des utilisateurs"
        );
      }

      dispatch({ type: FETCH_UTILISATEURS_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: FETCH_UTILISATEURS_FAILURE, payload: error?.message });

      notification.error({
        message:
          error?.message || "Erreur lors de la récupération des utilisateurs",
        duration: 5,
      });
    }
  };
};
